<!-- TOP (already shown) -->
<ng-container *ngIf="getPlacement('top') as topImgs">
    <div class="full-width-banner">
        <md-dynamic-banner
            [images]="topImgs"
            [isMobile]="isMobile"
            (bannerClick)="handleBannerClick('plp-top-' + sectionId, 0)"
            (bannerImpression)="
                handleBannerImpression($event, 'plp-top-' + sectionId)
            "
        >
        </md-dynamic-banner>
    </div>
</ng-container>

<!-- SCROLLABLE PANE -->
<div
    infiniteScroll
    [infiniteScrollContainer]="scrollablePane"
    [infiniteScrollDistance]="3"
    [infiniteScrollThrottle]="50"
    [scrollWindow]="false"
    [immediateCheck]="true"
    [infiniteScrollDisabled]="loadingMoreDeals"
    [alwaysCallback]="true"
    (scrolled)="onScroll()"
>
    <!-- Product skeletons while loading -->
    <div class="md-category-listings" *ngIf="busyLoadingData">
        <div
            class="md-cat-list-card-wrapper"
            *ngFor="let _ of [].constructor(10)"
        >
            <md-product-card-loading></md-product-card-loading>
        </div>
    </div>

    <!-- === PRODUCTS + BANNERS === -->
    <ng-container
        *ngFor="let row of productRows; let rowIdx = index; trackBy: trackByRow"
    >
        <div class="md-category-listings">
            <div
                class="md-cat-list-card-wrapper"
                *ngFor="let prod of row; trackBy: trackByProduct"
            >
                <md-product-card
                    [dealEntry]="prod"
                    (dealSelected)="
                        redirectToProdDetail(
                            prod.id,
                            prod.productPath,
                            prod.name
                        )
                    "
                ></md-product-card>
            </div>
        </div>

        <!-- Full-width banner after this row -->
        <ng-container *ngIf="getBannerAfterRow(rowIdx) as afterImgs">
            <div
                class="full-width-banner f-w-b"
                (click)="onParentDivClick($event)"
            >
                <md-dynamic-banner
                    class="list-banner-content"
                    [images]="afterImgs"
                    [isMobile]="isMobile"
                    (bannerClick)="
                        handleBannerClick(
                            'plp-' + sectionId + '-row' + rowIdx,
                            $event
                        )
                    "
                    (bannerImpression)="
                        handleBannerImpression($event, 'plp-top-' + sectionId)
                    "
                >
                </md-dynamic-banner>
            </div>
        </ng-container>
    </ng-container>

    <!-- LOAD-MORE indicator -->
    <div
        *ngIf="
            categoryData.length < totalRecords &&
            categoryData.length >= 20 &&
            loadingMoreDeals
        "
        class="view_more custom-user-review-div-23"
    >
        {{ "Loading more" | translate }}
    </div>

    <!-- NO-PRODUCT message -->
    <div
        class="md-category-no-product"
        *ngIf="categoryData?.length === 0 && !busyLoadingData"
    >
        {{ "There is no product in selected category" | translate }}
    </div>

    <!-- ALL-DEALS component -->
    <md-category-all-deals
        #allDeals
        *ngIf="
            categoryData.length === totalRecords &&
            totalRecords < 10 &&
            areFiltersApplied
        "
    >
    </md-category-all-deals>
</div>
